import { FC } from 'react'
import styles from './register-button.module.scss'
import Button from '../Button'
import classNames from '@/utils/helpers/class-names.helper'
import UserIcon from '@/components/icons/UserIcon'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'next/router'

type RegisterButtonProps = {
  className?: string
}

const RegisterButton: FC<RegisterButtonProps> = ({ className }) => {
  const router = useRouter()
  const { t } = useTranslation()

  const handleOpenRegistration = () => {
    router.push({ query: { ...router.query, auth: 'registration' } }, undefined, { scroll: false })
  }

  return (
    <Button
      className={classNames(styles.button, className)}
      iconClassName={styles.icon}
      icon={<UserIcon />}
      main
      onClick={handleOpenRegistration}
    >
      {t('registration')}
    </Button>
  )
}

export default RegisterButton
